import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import {
  IonImg,
  IonButton,
  IonSkeletonText,
  isPlatform
} from '@ionic/react'
import { ShareMenu } from '../../../components/common/ShareMenu'
import RssButton from '../../../components/core/player-parts/RssButton'
import ContentButton from '../../../components/core/player-parts/ContentButton'
import YokIcon from '../../../components/common/YokIcon'
import './styles.scss'

const PodcastHeader = (props) => {
  const { product, rssTrack } = props
  const { data, contents } = product
  const [defaultBodyContent, setDefaultBodyContent] = useState(false)
  const ref = useRef()

  useEffect(() => {
    ref.current.style.backgroundImage = `url(${data.image_banner})`
    if (navigator.userAgent.match(/(iPad|iPhone|iPod)/i)) {
      ref.current.style.backgroundAttachment = 'scroll'
    }
    if (!isPlatform('cordova')) {
      ref.current.querySelector('.img-logo').style.animation = '15s rotate linear infinite'
    }
    if (data.id_product_source === '1' || data.id_product_source === '2') {
      if (contents.length > 0 && parseInt(data.serialized) === 1) {
        const lastSeason = contents[contents.length - 1].content
        const lastChapter = lastSeason[lastSeason.length - 1]
        setDefaultBodyContent(lastChapter)
      }
      if (contents.length > 0 && parseInt(data.serialized) !== 1) {
        const lastSeason = contents
        const lastChapter = lastSeason[lastSeason.length - 1]
        setDefaultBodyContent(lastChapter)
      }
    }
  }, [data, contents])

  return (
    <div
      className='podcast-header'
      ref={ref}
    >

      <div
        className='content-container'
        itemScope
        itemType='http://schema.org/CreativeWork'
      >

        <meta itemProp='url' content={window.location.href} />
        <meta itemProp='name' content={data.product} />

        <section
          itemProp='publisher'
          itemScope
          itemType='http://schema.org/Organization'
        >
          <meta itemProp='url' content='https://yokradio.com/' />
          <meta itemProp='name' content='Yok Radio' />
          <div itemProp='logo' itemScope itemType='http://schema.org/ImageObject'>
            <meta itemProp='url' content='https://yokradio.com/assets/icon/android-chrome-1024x1024.png' />
          </div>
        </section>

        <section
          className='logo-container'
          itemProp='image'
          itemScope
          itemType='http://schema.org/ImageObject'
        >
          <meta itemProp='contentUrl' content={data.image_logo} />
          <IonImg
            className='img-logo'
            src={data.image_logo}
            alt={`Logo de ${data.product}`}
          />
        </section>

        <section className='actions-container'>
          {data.id_product_source === '1' && defaultBodyContent !== false &&
            <Link to={`/ver/${defaultBodyContent.id_content}_${defaultBodyContent.url_title}`}>
              <IonButton className='play-button'>
                Reproducir <YokIcon name='play-b' />
              </IonButton>
            </Link>}

          {data.id_product_source === '2' &&
            <ContentButton content={defaultBodyContent} large />}

          {(data.id_product_source === '3' && rssTrack === false) &&
            <IonSkeletonText className='play-button-skeleton' animated />}

          {(data.id_product_source === '3' && rssTrack !== false) &&
            <RssButton item={rssTrack} rssTitle={product.data.url_name} large />}
        </section>

        <section className='classification-container'>
          <h1 className='title'>
            {data.product}
          </h1>
          <p className='intro' itemProp='abstract'>
            {data.description}
          </p>
          <p className='classification'>
            {data.producer}
          </p>
          <p className='classification'>
            {data.classification}
          </p>
          <p className='classification'>
            {data.cast}
          </p>
          <p className='classification' itemProp='datePublished'>
            {data.year}
          </p>
        </section>

        <section className='share-buttons-container'>
          <ShareMenu
            title={data.product}
            intro={data.description}
            tags={[]}
            section='Yok Radio'
          />
        </section>

      </div>

    </div>
  )
}

export default PodcastHeader
